/**
 * SGKC030A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface StandardsunitfeeTankaDto {

    /**
     * ガス期区分コード
     */
    gasperiodDivcd?: string;
    /**
     * ガス期区分名称
     */
    gasperioddivisionAname?: string;
    /**
     * 料金表種別
     */
    feetableClsfy?: string;
    /**
     * 使用量下限
     */
    empamtLowerlimit?: number;
    /**
     * 使用量上限
     */
    empamtUpperlimit?: number;
    /**
     * 基準単位料金
     */
    standardsunitfee?: number;
}

